module.exports = __webpack_public_path__ + "img/news-feed.86de8fa.webp";